// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#_pg-app{padding:0!important}.link,.st-link{cursor:pointer}.st-link{text-decoration:underline}.info-text{text-align:left;font-size:14px;color:#742a2a;background:#fed7d7;padding:5px 10px;line-height:18px}", ""]);
// Exports
module.exports = exports;
